// extracted by mini-css-extract-plugin
export default {"container":"WarehousePickPack_container__7HYC8"};